import { render, staticRenderFns } from "./CoursewareExportWidget.vue?vue&type=template&id=709780f0&"
import script from "./CoursewareExportWidget.vue?vue&type=script&lang=js&"
export * from "./CoursewareExportWidget.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports